import type { Category } from '@/domain/entities/category.entity'
import type { CategoryDto } from './category.dto'

export const categoryMapper = {
  toCategory(dto: CategoryDto): Category {
    return { id: dto.id, name: dto.name, active: dto.active ?? true }
  },
}
